const _state = {
    loading: false,    
}

export const initialState = () => _state

export const state = initialState()